import * as React from 'react';
import styles from './confirmation-box.scss';
import { ButtonPrimary } from 'ui';

interface ConfirmationBoxProps {
  text?: string;
  buttonText?: string;
  onClick: (event?: any) => void;
}

export const ConfirmationBox = ({text, buttonText, onClick}: ConfirmationBoxProps) => (
  <div className={styles.modeInformation}>
  <p>
    {
      text || null
    }
    
  </p>
  <ButtonPrimary onClick={onClick}>
    {
      buttonText || null
    }
  </ButtonPrimary>
</div>
);
